<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.w_sroperationmanualadd_info > ''" class="checklist-h2 col-xs-12">{{ page.w_sroperationmanualadd_info | uppercase }}</label>
        <tt-select ttLabel="special_hrsno" [(ttModel)]="page.special_hrsno" [ttData]="operationNumbers" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-datetime ttLabel="first_alert_dt" [(ttModel)]="page.first_alert_dt" [ttMinutePrecision]="1"></tt-datetime>
        <tt-select ttLabel="special_resource_id_to_add" [(ttModel)]="page.special_resource_id_to_add" [ttData]="resources" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-button-save ttText="sroperationmanualadd_save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
</tt-page>
